export const isArray = Array.isArray;
//# sourceMappingURL=array.js.map